module.exports = __webpack_public_path__ + "static/media/LT.c708d058.txt";